var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "microphone-meter" },
    _vm._l(8, function (item) {
      return _c("div", {
        key: item,
        staticClass: "level-item",
        class: { "active-item": item <= _vm.barLevel },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }